import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isDebugModeSelector } from '../../redux/reducers/app/initialization';
import { DEFAULT_QUERY_PARAMS, MAX_LIMIT } from './constants';
import { useInfinityQueryGames } from './useQueryGames';

// TODO: temporary solution while search API does not ready on DE. Should be removed after release search API
export const getGamesSearch = (games = [], search) => {
  return games.filter((game) =>
    game.translationKey.toLowerCase().includes(search.toLowerCase())
  );
};

export const useInfinityQuerySearchGames = (query = {}, queryOptions = {}) => {
  const isDebugMode = useSelector(isDebugModeSelector);

  const {
    isLoading,
    isSuccess,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    data,
  } = useInfinityQueryGames(
    {
      ...DEFAULT_QUERY_PARAMS,
      status: isDebugMode ? 'ACTIVE,DEBUG' : 'ACTIVE',
      _limit: MAX_LIMIT,
    },
    queryOptions
  );

  const filterOldSearchApiData = useCallback(
    (data) => getGamesSearch(data?.pages, query?.search),
    [query?.search]
  );

  return useMemo(
    () => ({
      isLoading,
      isSuccess,
      isError,
      error,
      fetchNextPage,
      hasNextPage,
      data: filterOldSearchApiData(data),
    }),
    [
      isLoading,
      isSuccess,
      isError,
      error,
      fetchNextPage,
      hasNextPage,
      filterOldSearchApiData,
      data,
    ]
  );
};
